export default "__VITE_ASSET__D789BNqE__"